import { format, parseISO } from 'date-fns';

import { TranslateICUFn } from '~src/commons/utils/translations/translate';

import { Timespan } from '../../../../api/api';

export function formatTimespan(
  timespan: Timespan | undefined,
  translate: TranslateICUFn,
  useTimespan = true
): string {
  let res = '';

  if (timespan && useTimespan) {
    // handle new timespan object
    if (!!timespan.from && !!timespan.to) {
      // 1PM - 2PM
      res = respondWithInterval(timespan.from, timespan.to, translate);
    } else if (!timespan.from && !!timespan.to) {
      // Before 1PM
      res = respondWithEndTime(timespan.to, translate);
    } else if (!!timespan.from && !timespan.to) {
      // Around 1PM
      res = respondWithStartTime(timespan.from, translate);
    }
  }

  return res;
}

function respondWithInterval(start: string, end: string, translate: TranslateICUFn): string {
  if (start === end) {
    // Around 1PM
    return respondWithStartTime(start, translate);
  }
  const formattedStart = formatTime(start, translate);
  const formattedEnd = formatTime(end, translate);
  // ${formatTime (12PM)} ${formatTime (1PM)}
  return translate('widget.delivery_time.INTERVAL_TIMESPAN', {
    min: formattedStart,
    max: formattedEnd,
  });
}

export function respondWithEndTime(end: string, translate: TranslateICUFn): string {
  const formattedEnd = formatTime(end, translate);
  // Before ${formattedEnd}
  return translate('widget.delivery_time.MAX_TIMESPAN', { max: formattedEnd });
}

export function respondWithStartTime(start: string, translate: TranslateICUFn): string {
  const formattedStart = formatTime(start, translate);
  // Temp? might need to be able to switch between "around" and "from".
  // Around ${formattedStart (1PM)}
  return translate('widget.delivery_time.MIN_TIMESPAN', { min: formattedStart });
}

export function formatTime(time: string, translate: TranslateICUFn): string {
  const fakeDate = `1970-01-01T${time}`; // prefix with fake date to form valid date, parseable by date-fns
  try {
    const timeFormat =
      format(parseISO(fakeDate), 'm') === '0'
        ? translate('widget.delivery_time.HOURS_FORMAT_ZERO_MINUTES')
        : translate('widget.delivery_time.HOURS_FORMAT');
    // 11AM or 11:33AM
    return format(parseISO(fakeDate), timeFormat);
  } catch {
    return time;
  }
}
